<template>
  <div class="daily-report-list">
    <template v-if="notReady"></template>
    <template v-else-if="!searched && !notReady && !isOperationOffice && !isDepartment">
      <div class="not-searched">
        <label >{{ i18n.global.t('pages.common.list.runFilter') }}</label>
      </div>
    </template>
    <template v-if="listLoading">
      <div class="not-searched">
        <label>{{ i18n.global.t('pages.common.list.reading') }}</label>
      </div>
    </template>
    <ResizableList
      scrollAreaSelector=".v-table__wrapper"
    >
      <div class="table-scrollbar">
        <v-table>
          <thead>
            <tr class="table-header-row">
              <th class="p-1 pr-0">
                <div class="checkbox-in-grid align-middle">
                  <v-checkbox class="d-block"
                    outlined hide-details="false"
                    v-model="allSelect"
                    @change="toggleSelectAll"
                  />
                </div>
              </th>
              <th class="pl-0">{{ i18n.global.t('pages.dailyReports.tripId') }}</th>
              <th>{{ i18n.global.t('pages.dailyReports.leavingWarehouseDate') }}</th>
              <th>{{ i18n.global.t('pages.dailyReports.returningWarehouseDate') }}</th>
              <th>{{ i18n.global.t('pages.dailyReports.carNumber') }}</th>
              <th>{{ i18n.global.t('pages.dailyReports.driver') }}</th>
              <th>{{ i18n.global.t('pages.dailyReports.refuelingAmount') }}</th>
              <th>{{ i18n.global.t('pages.dailyReports.detailsRefuelingInput') }}</th>
              <th
                v-if="isDisplayDailyReportEditColumn()"
              >
                {{ i18n.global.t('pages.dailyReports.edit') }}
              </th>
              <th>{{ i18n.global.t('pages.dailyReports.updatedByAndDate') }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="items?.length != 0">
              <tr
                v-for="item in items"
                :key="item.delivery_plan_id"
              >
                <td class="p-1 pr-0">
                  <v-checkbox
                    class="align-middle checkbox-in-grid"
                    label=''
                    v-model="selectStatuses[`${item.delivery_plan_id}`]"
                    @change="toggleSelect"
                  />
                </td>
                <td class="pl-0">
                  <div class="d-flex flex-row">
                    <div class="d-flex flex-column justify-content-center">
                      <div class="d-flex">
                        {{ item.delivery_plan_id.substr(-7, 7) }}
                        <div class="edit-mark-space">
                          <span class="edit-mark" v-if="item.has_editted">*</span>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <copy_element :copyText="item.delivery_plan_id" size="small" />
                    </div>
                  </div>
                </td>
                <td>{{ datetimeFormat(item.leaving_warehouse_date_time) }}</td>
                <td>{{ datetimeFormat(item.returning_warehouse_date_time) }}</td>
                <td>{{ item.car_number }}</td>
                <td>
                  <span :class="hasDriver(item)">
                    {{ item.driver ? item.driver?.last_name + item.driver?.first_name : item.driver_id }}
                  </span>
                  <span v-if="item.has_changed_driver" class="m-0 change-mark">*</span>
                </td>
                <td>{{ item.fuel_economy }}</td>
                <td>
                  <update_modal
                    v-if="isDisplayUpdateModalIcon(item)"
                    :driverId="item?.driver?.id"
                    :operationOffice="item.operation_office"
                    :deliveryPlanId="item.delivery_plan_id"
                    @change="updateItem"
                    :showFlash="showFlash"
                    :createAuthority="createAuthority"
                    :updateAuthority="updateAuthority"
                    :createSpotAuthority="createSpotAuthority"
                  />
                </td>
                <td
                  v-if="isDisplayDailyReportEditColumn()"
                >
                  <span
                    v-if="reportEditMessageCondition(item)"
                    class="text-muted"
                  >
                    {{ displayProcessingMessage(item) }}
                  </span>
                  <EditIcon
                    v-else
                    :deliveryPlan="item"
                    :isOperationOffice="isOperationOffice"
                    :isDepartment="isDepartment"
                  />
                </td>
                <td>{{ item.latest_history }}</td>
              </tr>
            </template>
            <template v-else-if="searched && !listLoading">
              <tr>
                <td colspan="9">
                  {{ i18n.global.t('pages.common.list.noData') }}
                </td>
              </tr>
            </template>
          </tbody>
        </v-table>
      </div>
    </ResizableList>
  </div>
</template>

<script>
import EditIcon from '@/components/DailyReportParts/EditIcon.vue';
import UpdateModal from "@/components/DailyReportUpdateModal"
import CopyElement from "@/components/CopyElement"
import ResizableList from '@/components/ResizableList.vue';
import i18n from '@/lang/i18n';

  export default {
    setup() {
      return {
        i18n
      }
    },
    props: {
      searched: null,
      items: [],
      listLoading: {
        type: Boolean,
        default: false
      },
      showFlash: {
        type: Function
      },
      isOperationOffice: {
        type: Boolean
      },
      isDepartment: {
        type: Boolean
      },
      notReady: {
        type: Boolean
      },
      createAuthority: {
        type: Boolean
      },
      updateAuthority: {
        type: Boolean
      },
      createSpotAuthority: {
        type: Boolean
      },
    },
    data() {
      return {
        form: {},
        dailyReportList: [],
        selected: [],
        allSelect: false,
        selectStatuses: {},
      }
    },
    computed: {
      hasDriver() {
        return (item) => item.driver ? 'driver-found' : 'driver-missing';
      },
    },
    methods: {
      toggleSelectAll() {
        Object.keys(this.selectStatuses).forEach((key) => {
          this.selectStatuses[key] = this.allSelect
        })
        this.onChange()
      },
      toggleSelect() {
        this.allSelect = false
        this.onChange()
      },
      onChange() {
        const selected = []
        Object.keys(this.selectStatuses).forEach((key) => {
          if (this.selectStatuses[key]) {
            const item = this.items.find(item => item.delivery_plan_id == key)
            selected.push(item)
          }
        })
        this.$emit('select', selected)
      },
      updateItem(item) {
        this.$emit('changeItem')
      },
      datetimeFormat(datetime) {
        const d = new Date(datetime)
        const year = d.getFullYear()
        const month = (d.getMonth() + 1).toString().padStart(2, '0')
        const day = d.getDate().toString().padStart(2, '0')
        const hour = d.getHours().toString().padStart(2, '0')
        const minutes = d.getMinutes().toString().padStart(2, '0')
        return `${year}-${month}-${day} ${hour}:${minutes}`
      },
      isDisplayUpdateModalIcon(item) {
        return !item?.editable_actions?.divide.processing && !item?.editable_actions?.merge.processing
      },
      displayProcessingMessage(item) {
        if (item?.editable_actions?.divide?.processing) {
          return i18n.global.t('pages.dailyReports.splitProcessing')
        } else if (item?.editable_actions?.merge?.processing) {
          return i18n.global.t('pages.dailyReports.mergeProcessing')
        } else if (item?.editable_actions?.alter_leaving?.processing) {
          return i18n.global.t('pages.dailyReports.alterLeavingProcessing')
        } else if (item?.editable_actions?.alter_returning?.processing) {
          return i18n.global.t('pages.dailyReports.alterReturningProcessing')
        } else if (item?.editable_actions?.recreate?.processing) {
          return i18n.global.t('pages.dailyReports.recreateProcessing')
        }
      },
      isDisplayDailyReportEditColumn() {
        return this.updateAuthority
      },
      reportEditRoutingCondition(item) {
        return item.editable_actions.divide.available || item.editable_actions.merge.available
      },
      reportEditMessageCondition(item) {
        return item.editable_actions.divide.processing ||
          item.editable_actions.merge.processing ||
          item.editable_actions.alter_leaving.processing ||
          item.editable_actions.alter_returning.processing ||
          item.editable_actions.recreate.processing
      }
    },
    watch: {
      items: {
        handler() {
          this.allSelect = false;
          this.selectStatuses = {}
          this.items.map((v) => {
            this.selectStatuses[v['delivery_plan_id']] = false
          })
        }
      },
    },
    components: {
      update_modal: UpdateModal,
      copy_element: CopyElement,
      EditIcon: EditIcon,
      ResizableList: ResizableList
    }
  }

</script>

<style>
.daily-report-list .v-table__wrapper {
  height: var(--resizable-height, var(--list-default-height));
  overflow: auto;
}
</style>
<style scoped>
.daily-report-list {
  position: relative;
}
.daily-report-list table th {
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  min-width: 7em;
}
.daily-report-list table .table-header-row th {
  z-index: 1;
}
.daily-report-list table .table-header-row th:first-child {
  z-index: 2;
}
.checkbox-in-grid :first-child {
  height: inherit !important;
}
.checkbox-in-grid {
  display: inline-grid !important;
  transform: scale(1.2);
}
.edit-mark-space {
  width: 10px;
}
.edit-mark {
  color: red;
  margin-left: 3px;
}
.change-mark {
  color: red;
}
.driver-missing {
  color: red;
}
.driver-found {
  color: unset;
}
</style>
